/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
	  };
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GQLCreateCoverSheetEntityInput = {
	entity: string;
	entityType?: string | null | undefined;
	fields: Array<GQLUpdateCoverSheetFieldData>;
	interactionId: string;
	interactionType: GQLInteractionType;
};

export type GQLDeleteCoverSheetEntityInput = {
	entity: string;
	entityId: string;
	interactionId: string;
	interactionType: GQLInteractionType;
};

export type GQLInteractionType =
	| "clientGroup"
	| "lease"
	| "listing"
	| "offer"
	| "referral"
	| "userTemplate";

export type GQLLeaseRepresentation = "dual" | "landlord" | "tenant";

export type GQLUpdateCoverSheetFieldData = {
	name: string;
	value?: string | null | undefined;
};

export type GQLUpdateCoverSheetFieldsInput = {
	entity?: string | null | undefined;
	entityId?: string | null | undefined;
	fields: Array<GQLUpdateCoverSheetFieldData>;
	interactionId: string;
	interactionType: GQLInteractionType;
	representationType?: GQLLeaseRepresentation | null | undefined;
};

export type GQLCoverSheetMutationFieldsFragment = {
	__typename: "CoverSheet";
	id: string;
	interactionId: string;
	ownerUserIdentityId: string | null;
	teamIdentityId: string | null;
	insideListingDescription: string | null;
	isIntermediary: boolean | null;
	showOnInsideListings: boolean | null;
	onMarketDate: string | null;
	listingPrice: number | null;
	listingEndDate: string | null;
	property: {
		__typename: "PropertyInfo";
		id: string | null;
		street1: string | null;
		street2: string | null;
		city: string | null;
		state: string | null;
		zip: string | null;
		county: string | null;
		bedrooms: number | null;
		bathrooms: number | null;
		buildingArea: number | null;
		lotSize: number | null;
	} | null;
	contacts: Array<{
		id: string | null;
		addressTypeUsed: string | null;
		type: string | null;
		externalId: string | null;
		entityType: string | null;
		firstName: string | null;
		lastName: string | null;
		nickname: string | null;
		fullName: string | null;
		group: string | null;
		homePhone: string | null;
		cellPhone: string | null;
		etag: string | null;
		fax: string | null;
		email: string | null;
		street1: string | null;
		street2: string | null;
		city: string | null;
		state: string | null;
		zip: string | null;
		companyName: string | null;
		county: string | null;
		country: string | null;
		avatar: string | null;
		googleContactId: string | null;
		contactSource: string | null;
		userId: string | null;
		order: number | null;
		licenseNumber: string | null;
		mlsId: string | null;
		officeNumber: string | null;
		jurisdiction: string | null;
		primaryMls: string | null;
		commission: string | null;
		sellingCommission: string | null;
		listingPeriod: string | null;
		teamId: string | null;
		teamName: string | null;
		isSuccessor: boolean | null;
		isSelfRepresented: boolean | null;
		teamBusinessLicenseEntityNumber: string | null;
		role: string | null;
		confirmationNumber: string | null;
		escrowNumber: string | null;
		titleNumber: string | null;
		ownershipStatus: string | null;
		brokerage: {
			companyName: string | null;
			licenseNumber: string | null;
			mlsCode: string | null;
			street1: string | null;
			street2: string | null;
			city: string | null;
			state: string | null;
			zip: string | null;
		} | null;
		supervisingBroker: {
			firstName: string | null;
			lastName: string | null;
			licenseNumber: string | null;
			cellPhone: string | null;
			email: string | null;
		} | null;
		entity: {
			name: string | null;
			title: string | null;
			titleOther: string | null;
		} | null;
		probate: {
			name: string | null;
			title: string | null;
			titleOther: string | null;
		} | null;
		powerOfAttorney: {
			firstName: string | null;
			lastName: string | null;
			licenseNumber: string | null;
			cellPhone: string | null;
			email: string | null;
		} | null;
		trust: {
			name: string | null;
			title: string | null;
			titleOther: string | null;
		} | null;
	}>;
};

export type GQLCoverSheetQueryVariables = Exact<{
	interactionId: string | number;
	interactionType: Types.GQLInteractionType;
}>;

export type GQLCoverSheetQuery = {
	coverSheet: {
		__typename: "CoverSheet";
		id: string;
		interactionId: string;
		ownerUserIdentityId: string | null;
		teamIdentityId: string | null;
		insideListingDescription: string | null;
		isIntermediary: boolean | null;
		showOnInsideListings: boolean | null;
		onMarketDate: string | null;
		listingPrice: number | null;
		listingEndDate: string | null;
		property: {
			__typename: "PropertyInfo";
			id: string | null;
			street1: string | null;
			street2: string | null;
			city: string | null;
			state: string | null;
			zip: string | null;
			county: string | null;
			bedrooms: number | null;
			bathrooms: number | null;
			buildingArea: number | null;
			lotSize: number | null;
		} | null;
		contacts: Array<{
			id: string | null;
			addressTypeUsed: string | null;
			type: string | null;
			externalId: string | null;
			entityType: string | null;
			firstName: string | null;
			lastName: string | null;
			nickname: string | null;
			fullName: string | null;
			group: string | null;
			homePhone: string | null;
			cellPhone: string | null;
			etag: string | null;
			fax: string | null;
			email: string | null;
			street1: string | null;
			street2: string | null;
			city: string | null;
			state: string | null;
			zip: string | null;
			companyName: string | null;
			county: string | null;
			country: string | null;
			avatar: string | null;
			googleContactId: string | null;
			contactSource: string | null;
			userId: string | null;
			order: number | null;
			licenseNumber: string | null;
			mlsId: string | null;
			officeNumber: string | null;
			jurisdiction: string | null;
			primaryMls: string | null;
			commission: string | null;
			sellingCommission: string | null;
			listingPeriod: string | null;
			teamId: string | null;
			teamName: string | null;
			isSuccessor: boolean | null;
			isSelfRepresented: boolean | null;
			teamBusinessLicenseEntityNumber: string | null;
			role: string | null;
			confirmationNumber: string | null;
			escrowNumber: string | null;
			titleNumber: string | null;
			ownershipStatus: string | null;
			brokerage: {
				companyName: string | null;
				licenseNumber: string | null;
				mlsCode: string | null;
				street1: string | null;
				street2: string | null;
				city: string | null;
				state: string | null;
				zip: string | null;
			} | null;
			supervisingBroker: {
				firstName: string | null;
				lastName: string | null;
				licenseNumber: string | null;
				cellPhone: string | null;
				email: string | null;
			} | null;
			entity: {
				name: string | null;
				title: string | null;
				titleOther: string | null;
			} | null;
			probate: {
				name: string | null;
				title: string | null;
				titleOther: string | null;
			} | null;
			powerOfAttorney: {
				firstName: string | null;
				lastName: string | null;
				licenseNumber: string | null;
				cellPhone: string | null;
				email: string | null;
			} | null;
			trust: {
				name: string | null;
				title: string | null;
				titleOther: string | null;
			} | null;
		}>;
	} | null;
};

export type GQLCreateCoverSheetEntityMutationVariables = Exact<{
	input: Types.GQLCreateCoverSheetEntityInput;
}>;

export type GQLCreateCoverSheetEntityMutation = {
	coverSheet: {
		createEntity: {
			status: string;
			id: string | null;
			coverSheet: {
				__typename: "CoverSheet";
				id: string;
				interactionId: string;
				ownerUserIdentityId: string | null;
				teamIdentityId: string | null;
				insideListingDescription: string | null;
				isIntermediary: boolean | null;
				showOnInsideListings: boolean | null;
				onMarketDate: string | null;
				listingPrice: number | null;
				listingEndDate: string | null;
				property: {
					__typename: "PropertyInfo";
					id: string | null;
					street1: string | null;
					street2: string | null;
					city: string | null;
					state: string | null;
					zip: string | null;
					county: string | null;
					bedrooms: number | null;
					bathrooms: number | null;
					buildingArea: number | null;
					lotSize: number | null;
				} | null;
				contacts: Array<{
					id: string | null;
					addressTypeUsed: string | null;
					type: string | null;
					externalId: string | null;
					entityType: string | null;
					firstName: string | null;
					lastName: string | null;
					nickname: string | null;
					fullName: string | null;
					group: string | null;
					homePhone: string | null;
					cellPhone: string | null;
					etag: string | null;
					fax: string | null;
					email: string | null;
					street1: string | null;
					street2: string | null;
					city: string | null;
					state: string | null;
					zip: string | null;
					companyName: string | null;
					county: string | null;
					country: string | null;
					avatar: string | null;
					googleContactId: string | null;
					contactSource: string | null;
					userId: string | null;
					order: number | null;
					licenseNumber: string | null;
					mlsId: string | null;
					officeNumber: string | null;
					jurisdiction: string | null;
					primaryMls: string | null;
					commission: string | null;
					sellingCommission: string | null;
					listingPeriod: string | null;
					teamId: string | null;
					teamName: string | null;
					isSuccessor: boolean | null;
					isSelfRepresented: boolean | null;
					teamBusinessLicenseEntityNumber: string | null;
					role: string | null;
					confirmationNumber: string | null;
					escrowNumber: string | null;
					titleNumber: string | null;
					ownershipStatus: string | null;
					brokerage: {
						companyName: string | null;
						licenseNumber: string | null;
						mlsCode: string | null;
						street1: string | null;
						street2: string | null;
						city: string | null;
						state: string | null;
						zip: string | null;
					} | null;
					supervisingBroker: {
						firstName: string | null;
						lastName: string | null;
						licenseNumber: string | null;
						cellPhone: string | null;
						email: string | null;
					} | null;
					entity: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
					probate: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
					powerOfAttorney: {
						firstName: string | null;
						lastName: string | null;
						licenseNumber: string | null;
						cellPhone: string | null;
						email: string | null;
					} | null;
					trust: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
				}>;
			} | null;
		};
	};
};

export type GQLUpdateCoverSheetMutationVariables = Exact<{
	input: Types.GQLUpdateCoverSheetFieldsInput;
}>;

export type GQLUpdateCoverSheetMutation = {
	coverSheet: {
		updateCoverSheetFields: {
			status: string;
			coverSheet: {
				__typename: "CoverSheet";
				id: string;
				interactionId: string;
				ownerUserIdentityId: string | null;
				teamIdentityId: string | null;
				insideListingDescription: string | null;
				isIntermediary: boolean | null;
				showOnInsideListings: boolean | null;
				onMarketDate: string | null;
				listingPrice: number | null;
				listingEndDate: string | null;
				property: {
					__typename: "PropertyInfo";
					id: string | null;
					street1: string | null;
					street2: string | null;
					city: string | null;
					state: string | null;
					zip: string | null;
					county: string | null;
					bedrooms: number | null;
					bathrooms: number | null;
					buildingArea: number | null;
					lotSize: number | null;
				} | null;
				contacts: Array<{
					id: string | null;
					addressTypeUsed: string | null;
					type: string | null;
					externalId: string | null;
					entityType: string | null;
					firstName: string | null;
					lastName: string | null;
					nickname: string | null;
					fullName: string | null;
					group: string | null;
					homePhone: string | null;
					cellPhone: string | null;
					etag: string | null;
					fax: string | null;
					email: string | null;
					street1: string | null;
					street2: string | null;
					city: string | null;
					state: string | null;
					zip: string | null;
					companyName: string | null;
					county: string | null;
					country: string | null;
					avatar: string | null;
					googleContactId: string | null;
					contactSource: string | null;
					userId: string | null;
					order: number | null;
					licenseNumber: string | null;
					mlsId: string | null;
					officeNumber: string | null;
					jurisdiction: string | null;
					primaryMls: string | null;
					commission: string | null;
					sellingCommission: string | null;
					listingPeriod: string | null;
					teamId: string | null;
					teamName: string | null;
					isSuccessor: boolean | null;
					isSelfRepresented: boolean | null;
					teamBusinessLicenseEntityNumber: string | null;
					role: string | null;
					confirmationNumber: string | null;
					escrowNumber: string | null;
					titleNumber: string | null;
					ownershipStatus: string | null;
					brokerage: {
						companyName: string | null;
						licenseNumber: string | null;
						mlsCode: string | null;
						street1: string | null;
						street2: string | null;
						city: string | null;
						state: string | null;
						zip: string | null;
					} | null;
					supervisingBroker: {
						firstName: string | null;
						lastName: string | null;
						licenseNumber: string | null;
						cellPhone: string | null;
						email: string | null;
					} | null;
					entity: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
					probate: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
					powerOfAttorney: {
						firstName: string | null;
						lastName: string | null;
						licenseNumber: string | null;
						cellPhone: string | null;
						email: string | null;
					} | null;
					trust: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
				}>;
			} | null;
		};
	};
};

export type GQLDeleteCoverSheetEntityMutationVariables = Exact<{
	input: Types.GQLDeleteCoverSheetEntityInput;
}>;

export type GQLDeleteCoverSheetEntityMutation = {
	coverSheet: {
		deleteEntity: {
			status: string;
			coverSheet: {
				__typename: "CoverSheet";
				id: string;
				interactionId: string;
				ownerUserIdentityId: string | null;
				teamIdentityId: string | null;
				insideListingDescription: string | null;
				isIntermediary: boolean | null;
				showOnInsideListings: boolean | null;
				onMarketDate: string | null;
				listingPrice: number | null;
				listingEndDate: string | null;
				property: {
					__typename: "PropertyInfo";
					id: string | null;
					street1: string | null;
					street2: string | null;
					city: string | null;
					state: string | null;
					zip: string | null;
					county: string | null;
					bedrooms: number | null;
					bathrooms: number | null;
					buildingArea: number | null;
					lotSize: number | null;
				} | null;
				contacts: Array<{
					id: string | null;
					addressTypeUsed: string | null;
					type: string | null;
					externalId: string | null;
					entityType: string | null;
					firstName: string | null;
					lastName: string | null;
					nickname: string | null;
					fullName: string | null;
					group: string | null;
					homePhone: string | null;
					cellPhone: string | null;
					etag: string | null;
					fax: string | null;
					email: string | null;
					street1: string | null;
					street2: string | null;
					city: string | null;
					state: string | null;
					zip: string | null;
					companyName: string | null;
					county: string | null;
					country: string | null;
					avatar: string | null;
					googleContactId: string | null;
					contactSource: string | null;
					userId: string | null;
					order: number | null;
					licenseNumber: string | null;
					mlsId: string | null;
					officeNumber: string | null;
					jurisdiction: string | null;
					primaryMls: string | null;
					commission: string | null;
					sellingCommission: string | null;
					listingPeriod: string | null;
					teamId: string | null;
					teamName: string | null;
					isSuccessor: boolean | null;
					isSelfRepresented: boolean | null;
					teamBusinessLicenseEntityNumber: string | null;
					role: string | null;
					confirmationNumber: string | null;
					escrowNumber: string | null;
					titleNumber: string | null;
					ownershipStatus: string | null;
					brokerage: {
						companyName: string | null;
						licenseNumber: string | null;
						mlsCode: string | null;
						street1: string | null;
						street2: string | null;
						city: string | null;
						state: string | null;
						zip: string | null;
					} | null;
					supervisingBroker: {
						firstName: string | null;
						lastName: string | null;
						licenseNumber: string | null;
						cellPhone: string | null;
						email: string | null;
					} | null;
					entity: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
					probate: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
					powerOfAttorney: {
						firstName: string | null;
						lastName: string | null;
						licenseNumber: string | null;
						cellPhone: string | null;
						email: string | null;
					} | null;
					trust: {
						name: string | null;
						title: string | null;
						titleOther: string | null;
					} | null;
				}>;
			} | null;
		};
	};
};

export const CoverSheetMutationFieldsFragmentDoc = gql`
    fragment CoverSheetMutationFields on CoverSheet {
  __typename
  id
  interactionId
  ownerUserIdentityId
  teamIdentityId
  property {
    __typename
    id
    street1
    street2
    city
    state
    zip
    county
    bedrooms
    bathrooms
    buildingArea
    lotSize
  }
  insideListingDescription
  isIntermediary
  showOnInsideListings
  onMarketDate
  listingPrice
  listingEndDate
  contacts {
    id
    addressTypeUsed
    type
    externalId
    entityType
    firstName
    lastName
    nickname
    fullName
    group
    homePhone
    cellPhone
    etag
    fax
    email
    street1
    street2
    city
    state
    zip
    companyName
    county
    country
    avatar
    googleContactId
    contactSource
    userId
    order
    licenseNumber
    mlsId
    brokerage {
      companyName
      licenseNumber
      mlsCode
      street1
      street2
      city
      state
      zip
    }
    officeNumber
    jurisdiction
    primaryMls
    commission
    sellingCommission
    listingPeriod
    teamId
    teamName
    isSuccessor
    isSelfRepresented
    teamBusinessLicenseEntityNumber
    supervisingBroker {
      firstName
      lastName
      licenseNumber
      cellPhone
      email
    }
    entity {
      name
      title
      titleOther
    }
    probate {
      name
      title
      titleOther
    }
    powerOfAttorney {
      firstName
      lastName
      licenseNumber
      cellPhone
      email
    }
    trust {
      name
      title
      titleOther
    }
    role
    confirmationNumber
    escrowNumber
    titleNumber
    ownershipStatus
  }
}
    `;
export const CoverSheetDocument = gql`
    query CoverSheet($interactionId: ID!, $interactionType: InteractionType!) {
  coverSheet(
    input: {interactionId: $interactionId, interactionType: $interactionType}
  ) {
    ...CoverSheetMutationFields
  }
}
    ${CoverSheetMutationFieldsFragmentDoc}`;

/**
 * __useCoverSheetQuery__
 *
 * To run a query within a React component, call `useCoverSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverSheetQuery({
 *   variables: {
 *      interactionId: // value for 'interactionId'
 *      interactionType: // value for 'interactionType'
 *   },
 * });
 */
export function useCoverSheetQuery(
	baseOptions: Apollo.QueryHookOptions<
		GQLCoverSheetQuery,
		GQLCoverSheetQueryVariables
	> &
		(
			| { variables: GQLCoverSheetQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GQLCoverSheetQuery, GQLCoverSheetQueryVariables>(
		CoverSheetDocument,
		options,
	);
}
export function useCoverSheetLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GQLCoverSheetQuery,
		GQLCoverSheetQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GQLCoverSheetQuery, GQLCoverSheetQueryVariables>(
		CoverSheetDocument,
		options,
	);
}
// @ts-ignore
export function useCoverSheetSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GQLCoverSheetQuery,
		GQLCoverSheetQueryVariables
	>,
): Apollo.UseSuspenseQueryResult<
	GQLCoverSheetQuery,
	GQLCoverSheetQueryVariables
>;
export function useCoverSheetSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLCoverSheetQuery,
				GQLCoverSheetQueryVariables
		  >,
): Apollo.UseSuspenseQueryResult<
	GQLCoverSheetQuery | undefined,
	GQLCoverSheetQueryVariables
>;
export function useCoverSheetSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLCoverSheetQuery,
				GQLCoverSheetQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GQLCoverSheetQuery,
		GQLCoverSheetQueryVariables
	>(CoverSheetDocument, options);
}
export type CoverSheetQueryHookResult = ReturnType<typeof useCoverSheetQuery>;
export type CoverSheetLazyQueryHookResult = ReturnType<
	typeof useCoverSheetLazyQuery
>;
export type CoverSheetSuspenseQueryHookResult = ReturnType<
	typeof useCoverSheetSuspenseQuery
>;
export type CoverSheetQueryResult = Apollo.QueryResult<
	GQLCoverSheetQuery,
	GQLCoverSheetQueryVariables
>;
export const CreateCoverSheetEntityDocument = gql`
    mutation CreateCoverSheetEntity($input: CreateCoverSheetEntityInput!) {
  coverSheet {
    createEntity(input: $input) {
      status
      id
      coverSheet {
        ...CoverSheetMutationFields
      }
    }
  }
}
    ${CoverSheetMutationFieldsFragmentDoc}`;
export type GQLCreateCoverSheetEntityMutationFn = Apollo.MutationFunction<
	GQLCreateCoverSheetEntityMutation,
	GQLCreateCoverSheetEntityMutationVariables
>;

/**
 * __useCreateCoverSheetEntityMutation__
 *
 * To run a mutation, you first call `useCreateCoverSheetEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoverSheetEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoverSheetEntityMutation, { data, loading, error }] = useCreateCoverSheetEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoverSheetEntityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GQLCreateCoverSheetEntityMutation,
		GQLCreateCoverSheetEntityMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GQLCreateCoverSheetEntityMutation,
		GQLCreateCoverSheetEntityMutationVariables
	>(CreateCoverSheetEntityDocument, options);
}
export type CreateCoverSheetEntityMutationHookResult = ReturnType<
	typeof useCreateCoverSheetEntityMutation
>;
export type CreateCoverSheetEntityMutationResult =
	Apollo.MutationResult<GQLCreateCoverSheetEntityMutation>;
export type CreateCoverSheetEntityMutationOptions = Apollo.BaseMutationOptions<
	GQLCreateCoverSheetEntityMutation,
	GQLCreateCoverSheetEntityMutationVariables
>;
export const UpdateCoverSheetDocument = gql`
    mutation UpdateCoverSheet($input: UpdateCoverSheetFieldsInput!) {
  coverSheet {
    updateCoverSheetFields(input: $input) {
      status
      coverSheet {
        ...CoverSheetMutationFields
      }
    }
  }
}
    ${CoverSheetMutationFieldsFragmentDoc}`;
export type GQLUpdateCoverSheetMutationFn = Apollo.MutationFunction<
	GQLUpdateCoverSheetMutation,
	GQLUpdateCoverSheetMutationVariables
>;

/**
 * __useUpdateCoverSheetMutation__
 *
 * To run a mutation, you first call `useUpdateCoverSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverSheetMutation, { data, loading, error }] = useUpdateCoverSheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoverSheetMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GQLUpdateCoverSheetMutation,
		GQLUpdateCoverSheetMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GQLUpdateCoverSheetMutation,
		GQLUpdateCoverSheetMutationVariables
	>(UpdateCoverSheetDocument, options);
}
export type UpdateCoverSheetMutationHookResult = ReturnType<
	typeof useUpdateCoverSheetMutation
>;
export type UpdateCoverSheetMutationResult =
	Apollo.MutationResult<GQLUpdateCoverSheetMutation>;
export type UpdateCoverSheetMutationOptions = Apollo.BaseMutationOptions<
	GQLUpdateCoverSheetMutation,
	GQLUpdateCoverSheetMutationVariables
>;
export const DeleteCoverSheetEntityDocument = gql`
    mutation DeleteCoverSheetEntity($input: DeleteCoverSheetEntityInput!) {
  coverSheet {
    deleteEntity(input: $input) {
      status
      coverSheet {
        ...CoverSheetMutationFields
      }
    }
  }
}
    ${CoverSheetMutationFieldsFragmentDoc}`;
export type GQLDeleteCoverSheetEntityMutationFn = Apollo.MutationFunction<
	GQLDeleteCoverSheetEntityMutation,
	GQLDeleteCoverSheetEntityMutationVariables
>;

/**
 * __useDeleteCoverSheetEntityMutation__
 *
 * To run a mutation, you first call `useDeleteCoverSheetEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoverSheetEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoverSheetEntityMutation, { data, loading, error }] = useDeleteCoverSheetEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCoverSheetEntityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GQLDeleteCoverSheetEntityMutation,
		GQLDeleteCoverSheetEntityMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GQLDeleteCoverSheetEntityMutation,
		GQLDeleteCoverSheetEntityMutationVariables
	>(DeleteCoverSheetEntityDocument, options);
}
export type DeleteCoverSheetEntityMutationHookResult = ReturnType<
	typeof useDeleteCoverSheetEntityMutation
>;
export type DeleteCoverSheetEntityMutationResult =
	Apollo.MutationResult<GQLDeleteCoverSheetEntityMutation>;
export type DeleteCoverSheetEntityMutationOptions = Apollo.BaseMutationOptions<
	GQLDeleteCoverSheetEntityMutation,
	GQLDeleteCoverSheetEntityMutationVariables
>;
